export const config = {
  apiBaseUrl: normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL ?? ''),
  // NOTE: public google maps API can be versioned
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? 'AIzaSyDmAZ7qgS8c5J2wNm9ZfQKluvmDMIIfb8E',
} as const;

export function normalizeApiBaseUrl(value: string) {
  return value.trim().replace(/\/+$/, '');
}
